'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ../shortid/lib/util/cluster-worker-id-browser.js
// module id = 1363
// module chunks = 22